import React, {useState} from "react";
import {closeExchangeSell} from "../../api/exchangeSell";
import {ErrorBanner} from "../../components";
import {useAuth} from "../../auth";

export function CloseSellDispute({orderId, onClosed}: {orderId: string; onClosed: () => void}): JSX.Element {
    const {token} = useAuth();
    const [open, setOpen] = useState(false);
    const [reason, setReason] = useState("");
    const [pending, setPending] = useState(false);
    const [error, setError] = useState<unknown>(null);
    const submit = async (): Promise<void> => {
        if (!reason.trim() || pending) return;
        setPending(true); setError(null);
        try { await closeExchangeSell(token, orderId, {reason: reason.trim()}); onClosed(); }
        catch (err) { setError(err); }
        finally { setPending(false); }
    };
    return <>
        <button className="btn btn-danger" onClick={() => setOpen(true)}>Закрыть в неуспех</button>
        {open && <div className="confirm-backdrop"><div className="confirm-modal" role="dialog" aria-modal="true" aria-label="Закрыть в неуспех">
            <h3>Закрыть в неуспех</h3>
            <p>Заявка будет закрыта без автоматического возврата, даже если перевод уже наблюдался. Наблюдение прекратится; причина решения сохранится в истории.</p>
            <label className="requisites-field"><span>Причина закрытия</span><textarea autoFocus value={reason} rows={3} maxLength={2000} disabled={pending} onChange={(event) => setReason(event.target.value)}/></label>
            <ErrorBanner error={error} title="Не удалось закрыть заявку"/>
            <div className="confirm-actions"><button className="btn btn-ghost" disabled={pending} onClick={() => setOpen(false)}>Назад</button><button className="btn btn-danger" disabled={pending || !reason.trim()} onClick={() => void submit()}>{pending ? "Закрываем…" : "Подтвердить закрытие"}</button></div>
        </div></div>}
    </>;
}
